import React from 'react';
import { Button, CREATE, DELETE, useDataProvider, useNotify, refreshView, TopToolbar } from 'react-admin';
import { useDispatch } from 'react-redux';
import LockIcon from '@material-ui/icons/Lock';
import ActivateIcon from '@material-ui/icons/LockOpen';
import DeleteIcon from '@material-ui/icons/Delete';

export default ({ data }) => {
	const dataProvider = useDataProvider();
	const notify = useNotify();
	const dispatch = useDispatch();

	const handleAction = (method) => {
		dataProvider(method === 'delete' ? DELETE : CREATE, 'marketplaces', {
			id: data.id,
			method: method,
		})
			.then(() => {
				notify(method === 'delete' ? 'resources.marketplaces.notifications.successfullyDeleted' : 'resources.marketplaces.notifications.successfullyUpdated', 'info');
			})
			.catch((error) => {
				notify(error.message, 'error');
			})
			.finally(() => {
				dispatch(refreshView());
			});
	};

	const activate = () => {
		handleAction('activate');
	};

	const lock = () => {
		handleAction('lock');
	};

	const remove = () => {
		handleAction('delete');
	};

	return (
		<TopToolbar>
			{data && (
				<Button label="resources.marketplaces.actions.activate" component="button" color="primary" onClick={activate} disabled={data.status !== 'Created' && data.status !== 'Locked'}>
					<ActivateIcon />
				</Button>
			)}
			{data && (
				<Button label="resources.marketplaces.actions.lock" component="button" color="primary" onClick={lock} disabled={data.status !== 'Created' && data.status !== 'Active'}>
					<LockIcon />
				</Button>
			)}
			{data && (
				<Button label="resources.marketplaces.actions.delete" component="button" color="primary" onClick={remove} disabled={data.status === 'Deleted'}>
					<DeleteIcon />
				</Button>
			)}
		</TopToolbar>
	);
};
